import { Routes, Route } from "react-router-dom";
import { GetSport, GetAllSports } from "./pages/Sports";
import { GetConf, GetAllConf } from "./pages/Conf";
import { GetDivision, GetAllDivision } from "./pages/Division";
import { GetPlayer } from "./pages/Player";
import { GetTeam } from "./pages/Team";
import Homepage from "./Homepage";
import AboutUs from "./pages/About";
import { FanPage, AthletePage, ProgramPage } from "./pages/Content";
import { ProfilePage } from "./pages/Profile";

import { SearchResults } from "./Search";
// import { TestRoute } from "./Test";
import { PaymentState } from "./pages/Payment";

import { TOS } from "./pages/About/tos";
import { PrivacyPolicy } from "./pages/About/privacy";
import Contact from "./pages/About/contact";

export const GetRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Homepage />} />

      <Route path="/About" element={<AboutUs />} />
      <Route path="/About/TOS" element={<TOS />} />
      <Route path="/About/Privacy" element={<PrivacyPolicy />} />
      <Route path="/About/Contact" element={<Contact />} />

      <Route path="/Profile" element={<ProfilePage />} />
      <Route path="/Sport" element={<GetAllSports />} />
      <Route path="/Sport/:id" element={<GetSport />} />
      <Route path="/Player/:id" element={<GetPlayer />} />
      <Route path="/Team/:id" element={<GetTeam />} />

      <Route path="/Conf" element={<GetAllConf />} />
      <Route path="/Conf/:id" element={<GetConf />} />

      <Route path="/Division" element={<GetAllDivision />} />
      <Route path="/Division/:id" element={<GetDivision />} />

      <Route path="/payment/:state/:redirect_url" element={<PaymentState />} />

      <Route path="/pages/Fans" element={<FanPage />} />
      <Route path="/pages/Athletes" element={<AthletePage />} />
      <Route path="/pages/Programs" element={<ProgramPage />} />

      <Route path="/search/results" element={<SearchResults />} />
      {/*<Route path="/test/:id" element={<TestRoute />} />*/}
    </Routes>
  );
};
